/** One message the team has sent a member. */
export interface MemberContactDto {
  userId: string;
  contactedAt: string;
  channel: string;
  sentBy: string;
  chatId: string;
  preview: string;
  /** The account it went out as. */
  fromUid?: string;
}

/** An account the admin can write to members as. */
export interface ChatSenderDto {
  uid: string;
  /** "NX2U Team", "David Grammig". */
  label: string;
  /** The first name the openers sign with. */
  signsAs: string;
  isDefault: boolean;
}

/** The state of the chat between the chosen sender and one member. */
export interface TeamChatStateDto {
  /** The chosen sender; same as fromUid. */
  teamUid: string;
  fromUid: string;
  senders: ChatSenderDto[];
  chatId: string;
  exists: boolean;
  messageCount: number;
  lastMessageAt: string | null;
  /** Messages the member sent. Zero means they have not answered. */
  fromMember: number;
  fromTeam: number;
  blockedByMember: boolean;
  contacts: MemberContactDto[];
}

export interface TeamMessageSentDto {
  chatId: string;
  isNew: boolean;
  sentAt: string;
}

/**
 * Saved openers.
 *
 * Kept as a short list rather than free text every time: the same three
 * questions go to twenty people, and retyping them is how the wording drifts
 * and a name ends up in the wrong message. Every one is editable before it is
 * sent - {name} is replaced with the member's first name, {sender} with the
 * first name of whoever it goes out as.
 */
export interface OpenerDto {
  key: string;
  label: string;
  text: string;
}

export const TEAM_OPENERS: OpenerDto[] = [
  {
    key: 'feedback',
    label: 'Ask for feedback',
    text:
      "Hi {name}, {sender} here from the NX2U team. You're one of the people who " +
      'actually use the app, so I would rather ask you than guess: what made you ' +
      'install it, and what would make it worth opening more often? A sentence or ' +
      'two is plenty.',
  },
  {
    key: 'welcome',
    label: 'Welcome a new member',
    text:
      "Hi {name}, welcome to NX2U. I'm {sender} from the team. If anything is " +
      'confusing or missing, tell me here - I read every message.',
  },
  {
    key: 'after-event',
    label: 'After an event',
    text:
      "Hi {name}! {sender} from NX2U here 👋 Hope the event was a good one. " +
      "I'm curious how it went for you - did you meet anyone interesting through " +
      "the app? Anything that made you smile, or anything that got in the way? " +
      "Even a quick line helps a lot, and I read every reply.",
  },
  {
    key: 'lapsed',
    label: 'Ask why they stopped',
    text:
      'Hi {name}, {sender} from NX2U. You used the app for a while and then stopped, ' +
      'and I would honestly like to know why. No pitch, just curious what was missing.',
  },
];
